export type FonteCustoInicial = 'unitario' | 'total';

export class PreparadorEstoqueInicial {
  static altereQuantidade(estoque: any, valor: number, fonte: FonteCustoInicial): void {
    estoque.quantidade = valor;
    if(!(Number(valor) > 0)){
      delete estoque.custoUnitarioInicial;
      delete estoque.custoTotalInicial;
      return;
    }
    if(fonte === 'total' && estoque.custoTotalInicial != null)
      this.altereTotal(estoque, estoque.custoTotalInicial);
    else if(estoque.custoUnitarioInicial != null)
      this.altereUnitario(estoque, estoque.custoUnitarioInicial);
  }

  static altereUnitario(estoque: any, valor: number): void {
    estoque.custoUnitarioInicial = valor;
    if(Number(estoque.quantidade) > 0 && valor != null)
      estoque.custoTotalInicial = this.arredonde(Number(estoque.quantidade) * Number(valor));
  }

  static altereTotal(estoque: any, valor: number): void {
    estoque.custoTotalInicial = valor;
    if(Number(estoque.quantidade) > 0 && valor != null)
      estoque.custoUnitarioInicial = this.arredonde(Number(valor) / Number(estoque.quantidade));
  }

  static prepareInsumo(insumo: any, ativo: boolean, fonte: FonteCustoInicial): any {
    if(!ativo || insumo.id || !insumo.estoque)
      return insumo;
    const dados = Object.assign({}, insumo, {estoque: Object.assign({}, insumo.estoque)});
    if(!(Number(dados.estoque.quantidade) > 0)){
      delete dados.estoque.custoUnitarioInicial;
      delete dados.estoque.custoTotalInicial;
    } else if(fonte === 'total') {
      delete dados.estoque.custoUnitarioInicial;
    } else {
      delete dados.estoque.custoTotalInicial;
    }
    return dados;
  }

  private static arredonde(valor: number): number {
    return Number(Number(valor).toFixed(6));
  }
}
